module.exports = __webpack_public_path__ + "static/media/Pixel Digivolve.b2c022a2.ttf";